import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem, Select } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { PreapprovalPeriodType } from '~/models/service-billing/model';
export const preapprovalPeriodOptionValues = [
    PreapprovalPeriodType.Weekly,
    PreapprovalPeriodType.BiWeekly,
    PreapprovalPeriodType.Monthly,
    PreapprovalPeriodType.Quarterly,
    PreapprovalPeriodType.Yearly,
    PreapprovalPeriodType.NoTimeLimit
];
export const preapprovalPeriodLabelKey = {
    [PreapprovalPeriodType.Weekly]: 'weekly',
    [PreapprovalPeriodType.BiWeekly]: 'biWeekly',
    [PreapprovalPeriodType.Monthly]: 'monthly',
    [PreapprovalPeriodType.Quarterly]: 'quarterly',
    [PreapprovalPeriodType.Yearly]: 'yearly',
    [PreapprovalPeriodType.NoTimeLimit]: 'noTimeLimit'
};
export function PreapprovalPeriodDropdown(param) {
    let { value, onChange, disabled, testId = 'preapproval-period-select', width, size } = param;
    const { t: preapprovalTexts } = useLocaleKeys('billing.preapproval');
    return /*#__PURE__*/ _jsx(Select, {
        bi: {
            name: 'preapproval_period'
        },
        label: preapprovalTexts.periodLabel(),
        value: value !== null && value !== void 0 ? value : '',
        onChange: onChange,
        disabled: disabled,
        testId: testId,
        width: width,
        size: size,
        children: preapprovalPeriodOptionValues.map((optionValue)=>/*#__PURE__*/ _jsx(MenuItem, {
                value: optionValue,
                testId: "preapproval-period-opt-".concat(optionValue),
                children: preapprovalTexts.periodOptions[preapprovalPeriodLabelKey[optionValue]]()
            }, optionValue))
    });
}
